export default function animate(el, styles = {}, duration = 300, easing = 'ease', callback) {
	el.style.transition = Object.entries(styles).map(([property]) => `${property} ${duration}ms ${easing}`);

	Object.entries(styles).forEach(([property, value]) => {
		el.style[property] = value;
	});

	const done = () => {
		el.removeEventListener('transitionEnd', done);
		el.style.removeProperty('transition');

		if (typeof callback === 'function') {
			callback();
		}
	};

	el.removeEventListener('transitionEnd', done);
}
